<div class="pag-container">



  <app-campaign-3-breadcrumb #breadcrumbComponent [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)" homeLink=""></app-campaign-3-breadcrumb>

  <div class="search-section">
    <h2>{{ 'challenge.participants_overview' | translate }}</h2>

    <form class="search-fields" (ngSubmit)="search()">
      <!-- Challenge -->
      <div class="field-group">
        <app-form-fields #challengeField data-testid="challenge" [filterable]="true"
          [(fieldModel)]="fieldModel.searchChallenge"  [type]="'dropdown'"
          [options]="challengeList" [name]="'challenge'" [optionLabel]="'display'"
          [placeholder]="'challenge.challenge_select_placeholder' | translate" [required]="true"
          [label]="'challenge.selectChallenge' | translate" (fieldModelChange)="onChallengeSelected()">
        </app-form-fields>
      </div>
      <div class="field-group" *ngIf="showLevelsSelection">
        <!-- challenge's level   -->
        <app-form-fields *ngIf="showLevelsSelection" #levelField data-testid="level" [filterable]="false"
          [(fieldModel)]="fieldModel.searchLevel" [type]="'dropdown'" [options]="levelsList" [name]="'level'"
          [optionLabel]="'label'" [placeholder]="'challenge.level_select_placeholder' | translate" [required]="true"
          [label]="'challenge.selectLevel' | translate">
        </app-form-fields>
      </div>

      <!-- RIGA CON 3 CAMPI -->
      <div class="field-row" style="padding-right: 17px;">

        <!-- Data Inizio -->
        <div class="field-group"
          *ngIf="srvCalendar && srvCalendar.pcalendarTranslate && srvCalendar.pcalendarTranslate.dateFormat">
          <app-form-fields #start_date_field data-testid="start_date_field" [label]="'challenge.start_date' | translate"
            [(fieldModel)]="fieldModel.searchDateStart" [type]="'date'" [required]="true"
            [placeholder]="'challenge.select_start_date' | translate">
          </app-form-fields>
        </div>

        <!-- Data Fine -->
        <div class="field-group"
          *ngIf="srvCalendar && srvCalendar.pcalendarTranslate && srvCalendar.pcalendarTranslate.dateFormat">
          <app-form-fields #end_date_field data-testid="end_date_field" [label]="'challenge.end_date' | translate"
            [(fieldModel)]="fieldModel.searchEndDate" [type]="'date'" [required]="true"
            [placeholder]="'challenge.select_end_date' | translate">
          </app-form-fields>
        </div>


      </div>
      <div class="field-row">

        <!-- ACM e min e max balance -->
        <div class="field-group">
          <app-form-fields #acmField *ngIf="readyAcm" data-testid="acmField" [(fieldModel)]="fieldModel.acm"
            [type]="'dropdown'" [options]="acmList" [name]="'acm'" [optionLabel]="'label'"
            [placeholder]="'challenge.acm' | translate" [required]="true" [label]="'challenge.acm' | translate">
          </app-form-fields>
        </div>

        <div class="field-group">
          <app-form-fields #minBalance data-testid="minBalanceField" [(fieldModel)]="fieldModel.minBalance"
            [type]="'number'" [name]="'minBalance'" [placeholder]="'challenge.selectMinBalance' | translate"
            [required]="false" [label]="'challenge.minBalance' | translate">
          </app-form-fields>
        </div>

        <div class="field-group">
          <app-form-fields #maxBalance data-testid="maxBalanceField" [(fieldModel)]="fieldModel.maxBalance"
            [type]="'number'" [name]="'maxValueAcm'" [placeholder]="'challenge.selectMaxBalance' | translate"
            [required]="false" [label]="'challenge.maxBalance' | translate">
          </app-form-fields>
        </div>


      </div>

      <!-- Bottone -->
      <button type="submit">{{ 'challenge.search' | translate }}</button>
    </form>
  </div>



  <div class="ui-g-12" *ngIf="showTable">

    <div class="header-row" *ngIf="showTable">
      <h1 class="title" style="margin:5px">
        {{ 'challenge.challenge_graphics_details' | translate }}
      </h1>
    </div>

    <app-campaign-3-kontable #participantOverviewTable *ngIf="showTable" [columns]="[
    {
      field: 'customerCode',
      title: 'customerDetail.code',
      filterType: textFilter
    },{
      field: 'customerName',
      title: 'challenge.customerName',
      filterType: textFilter
    },
      {
      field: 'customerSurname',
      title: 'challenge.surname',
      filterType: textFilter
    },
    {
      field: 'cardNo',
      title: 'challenge.card',
      filterType: textFilter
    },
    {
      field: 'challengeTitle',
      title: 'challenge.challenge',
      filterType: textFilter
    },
    {
      field: 'levelCode',
      title: 'challenge.level',
      filterType: textFilter
    },
    {
      field: 'acceptanceDate',
      title: 'challenge.acceptation',
      filterType: dateFilter,
      bodyTemplate: accDateTemplate 

    },
    {
      field: 'firstMovementDate',
      title: 'challenge.first_movement',
      filterType: dateFilter,
      bodyTemplate: firstDateTemplate 


    },
    {
      field: 'levelAchievementDate',
      title: 'challenge.level_reached_date',
      filterType: dateFilter,
      bodyTemplate: achivementDateTemplate 

    },
    {
      field: 'balance',
      title: 'challenge.balance',
      filterType: textFilter,
      bodyTemplate:balanceTemplate  
    },
       {
      field: 'progressPercentage',
      title: 'challenge.percentage',
      filterType: textFilter,
      bodyTemplate:percentegeTemplate  
    }

  ]" [service]="challengeOverviewService" [paginationType]="paginationType" [showRecoverButton]="false"
      [showInfoButton]="false" [showAddButton]="false" [showDeleteButton]="false" [showDetailsButton]="false"
      [showEditButton]="false" [filterBySingleColumn]="true" [additionalRowCommands]="actions"
      [showGlobalFilter]="false" [expandTable]="false" [showDownloadExcelBtn]="true"
      (onDownloadExcel)="downloadExcel($event)" [subjectToLoad]="pageSubject" [showRowButtons]=" false">


      <ng-template #balanceTemplate let-row>
        <span class="center-number">
          {{ row.balance }}
        </span>
      </ng-template>


      <ng-template #percentegeTemplate let-row>
        <span class="center-number">
          {{ row.progressPercentage | percent:'1.0-0' }}
        </span>
      </ng-template>
       <ng-template #accDateTemplate let-row>
                <span >{{
                    row.acceptanceDate |
                      date:srvCalendar.pcalendarTranslate.dateFormatFilter
                  }}</span>
      </ng-template>

      <ng-template #firstDateTemplate let-row>
                <span >{{
                    row.firstMovementDate |
                      date:srvCalendar.pcalendarTranslate.dateFormatFilter
                  }}</span>
      </ng-template>

    
           <ng-template #achivementDateTemplate let-row>
                <span >{{
                    row.levelAchievementDate |
                      date:srvCalendar.pcalendarTranslate.dateFormatFilter
                  }}</span>
      </ng-template>

    </app-campaign-3-kontable>


  </div>







  <div class="ui-g-12" *ngIf="showTableExport">

    <div class="header-row" *ngIf="showTableExport">
      <h1 class="title" style="margin:5px">
        {{ 'challenge.challenge_graphics_details_exports' | translate }}
      </h1>
    </div>

    <app-campaign-3-kontable #excellReportTable *ngIf="showTableExport" [columns]="[
      {
      field: 'id',
      title: 'challenge.idReport',
      filterType: textFilter
    },
     {
      field: 'fileName',
      title: 'challenge.fileName',
      filterType: textFilter,
      bodyTemplate: fileNameTemplate

    },
    {
      field: 'challengeId',
      title: 'challenge.challengeId',
      filterType: textFilter
    },
     
    {
      field: 'queryCondition',
      title: 'challenge.queryCondition',
      filterType: textFilter
    },
    {
      field: 'mineType',
      title: 'challenge.mineType',
      filterType: textFilter
    },
    {
      field: 'reportState',
      title: 'challenge.reportState',
      filterType: selectFilter,
      filterOptions: { values: reportStateList },
      bodyTemplate: reportStatesTemplate
    },
    {
      field: 'queryCount',
      title: 'challenge.queryCount',
      filterType: textFilter
    },
    {
      field: 'creationDate',
      title: 'challenge.creationDate',
      filterType: dateFilter,
      bodyTemplate: dateTemplate 
    }

  ]" [service]="challengeOverviewExportService" [paginationType]="paginationType" [showRecoverButton]="false"
      [showInfoButton]="false" [showAddButton]="false" [showDeleteButton]="false" [showDetailsButton]="false"
      [showEditButton]="false" [filterBySingleColumn]="true" [additionalRowCommands]="actions"
      [showGlobalFilter]="false" [expandTable]="false" [showDownloadExcelBtn]="false" [subjectToLoad]="pageSubject"
      [showRowButtons]="true">

      <ng-template #fileNameTemplate let-row>
        <span [title]="row.fileName">
          {{ getFileName(row.fileName) }}
        </span>
      </ng-template>

      <ng-template #reportStatesTemplate let-row>
        <span [title]="row.fileName">
          {{ getReportStatus(row.reportState) }}
        </span>
      </ng-template>


      <ng-template #dateTemplate let-row>
                <span >{{
                    row.creationDate |
                      date:srvCalendar.pcalendarTranslate.dateFormatFilter
                  }}</span>
      </ng-template>

      <!-- Azioni riga -->
      <ng-template #actions let-row>

        <div class="d-flex justify-content-center">


          <button class="roundedButton row-buttom-margin" pTooltip="{{ 'common.actions' | translate }}"
            data-testid-generic="challengeActions" [attr.data-testid]="'challengeActions' + row.id"
            (click)="toggleMenu(row)">
            <i class="pi pi-ellipsis-h icon-size"></i>
          </button>

          <!-- error log -->
          <div *ngIf="this.exportErrorPermission">
            <button class="roundedButton" pTooltip="{{ 'common.actions' | translate }}"
              data-testid-generic="challengeActions" [attr.data-testid]="'challengeActions' + row.id"
              (click)="infoErrorExport(row)">
              <i class="pi pi-info-circle icon-size"></i>
            </button>
          </div>
        </div>

        <!-- Dropdown azioni -->
        <div class="dropdown-menu" *ngIf="showMenu && row.id == currentOpenedRow">


          <!-- publish -->
          <button class="dropdown-item-creation" data-testid-generic="obtainReport" [disabled]="row.reportState != 1"
            (click)="obtainReport(row)">
            {{ 'challenge.obtain_report' | translate }}
          </button>

          <button class="dropdown-item-creation" data-testid-generic="deleteReport" [disabled]="row.reportState === 0"
            (click)="deleteReport(row)">
            {{ 'challenge.delete_report' | translate }}
          </button>




        </div>

      </ng-template>


    </app-campaign-3-kontable>


  </div>



  <!-- Popup cancellazione -->
  <p-dialog class="custom-dialog" header="{{ 'challenge.confirm_delete_report' | translate }}"
    [(visible)]="displayDeleteDialog" [modal]="true" [closable]="false">

    <div>
      {{ 'challenge.confirm_delete_message_report' | translate }}
    </div>

    <div class="custom-footer">
      <button type="button" pButton icon="pi pi-times" label="{{ 'common.cancel' | translate }}"
        (click)="closePopupDelete()">
      </button>

      <button type="button" pButton icon="pi pi-check" label="{{ 'common.confirm' | translate }}"
        style="margin-left: .25em" (click)="onDefinitiveDelete(reportToDelete)">
      </button>
    </div>

  </p-dialog>

  <div *ngIf="showPopupInfoDownload">
    <p-dialog header="{{ 'challenge.detailDownload' | translate }}" [(visible)]="showPopupInfoDownload" [modal]="true"
      [style]="{width: '60vw', height: '90vh'}" [draggable]="false" [resizable]="false"
      (onHide)="onClosePopupInfoDownload()">
      <pre>{{ 'challenge.msgDetailDownload' | translate }}</pre>
    </p-dialog>
  </div>

  <div *ngIf="showPopupInfoErrorExport">
    <p-dialog header="{{ 'challenge.msgDetailErrorExport' | translate }}" [(visible)]="showPopupInfoErrorExport"
      [modal]="true" [style]="{width: '60vw', height: '90vh'}" [draggable]="false" [resizable]="false"
      (onHide)="onClosePopupInfoErrorExport()">
      <pre>{{reportError}}</pre>
    </p-dialog>
  </div>

</div>


// WEBPACK FOOTER //
// ./src/app/views/challenge/challenge-graphics-details/challenge-graphics-details.component.html